import React, { useEffect, useRef, useState } from 'react'
import parse from 'html-react-parser';
import { useConfigContext } from '../../hooks/useConfigContext'
import copys from '../../utils/copys';
import Cookies from 'js-cookie';
import { ACCEPTED_COOKIE_NOT_LOGGED_IN_COOKIE_NAME, COOKIE_POLICY_COOKIE_NAME } from '../../utils/constants';
import { postAcceptCookies } from '../../services/authService/authService';
import './ModalCookies.css';
import { getPrivacyPolicies } from '../../services/commonService';
import { useAuthContext } from '../../hooks/useAuthContext';
import { cn } from '../../utils/cn';

type ModalCookiesProps = {
    onAccept: () => void;
}

const ModalCookies = ({ onAccept }: ModalCookiesProps) => {

    const { cookiePolicyAdviceText, cookiePolicyVersion } = useConfigContext();
    const { userData } = useAuthContext();
    const containerCookiesRef = useRef<HTMLDivElement>(null);
    const containerPrivacyRef = useRef<HTMLDivElement>(null);

    const [showCookiesAdvice, setShowCookiesAdvice] = useState(true);
    const [privacyPolicyContent, setPrivacyPolicyContent] = useState('');

    useEffect(() => {
        // Así el usuario no puede interactuar indirectamente con la app detrás.
        document.body.style.overflow = 'hidden';

        //adjuntar evento de click del aviso de privacidad
        const container = containerCookiesRef.current;
        if (!container) return;

        const handleClick = async(event: MouseEvent) => {
            const target = event.target as HTMLElement;

            if (target.id === 'inline_link') {
                event.preventDefault();
                try{
                    const {successful, data, errors} = await getPrivacyPolicies();
                    if(successful){
                        setPrivacyPolicyContent(data.content);
                        setShowCookiesAdvice(false);
                    }else{
                        console.log('Error fetching privacy policies: ', errors);
                    }
                }catch(error){
                    console.log('Error fetching privacy policies: ', error);
                }
            }
        };

        container.addEventListener('click', handleClick);

        return () => {
            document.body.style.overflow = '';
            container.removeEventListener('click', handleClick);
        };
    }, [showCookiesAdvice]);

    const acceptCookies = async () => {
        if (cookiePolicyVersion) {
            Cookies.set(COOKIE_POLICY_COOKIE_NAME, cookiePolicyVersion, {
                expires: 3650,
                sameSite: 'Lax',
                path: '/',
            })
            onAccept();
            if(userData.isLogged){
                await postAcceptCookies(cookiePolicyVersion);
            }else{
                Cookies.set(ACCEPTED_COOKIE_NOT_LOGGED_IN_COOKIE_NAME, cookiePolicyVersion, {
                    expires: 3650,
                    sameSite: 'Lax',
                    path: '/',
                });
            }
        }
    }
    return (
        <div className={cn("bg-black/50 w-screen h-dvh px-2 md:px-0 fixed inset-0 z-[999999] flex flex-col justify-end items-center", !showCookiesAdvice && 'md:justify-center')}>
            <div className={cn('bg-white flex flex-col px-4 pt-6 pb-10 gap-6 rounded w-full', showCookiesAdvice ? 'md:flex-row md:items-center md:pl-[73.5px] md:pr-[41.5px] md:py-8 md:gap-[10px] md:rounded-none':'md:w-[464px] md:h-[65dvh] md:px-6 md:rounded-[20px]')}>
                {
                    showCookiesAdvice &&
                    <>
                        <div className='flex flex-col gap-2' id="cookiePolicyAdviceText" ref={containerCookiesRef}>
                            {parse(cookiePolicyAdviceText)}
                        </div>
                        <div id='button_accept_cookies' onClick={acceptCookies} className='bg-[#100E9D] hover:bg-[#110f58] active:bg-[#8b8ab3] text-white cursor-pointer h-10 font-semibold text-base rounded-lg flex justify-center items-center md:px-4 md:py-2 md:min-w-[182px] md:max-w-[182px]'>
                            {copys.buttonAcceptCookies}
                        </div>
                    </>
                }
                {
                    !showCookiesAdvice &&
                    <>
                        <div className='flex flex-col gap-4 overflow-y-auto h-[70vh]' id="privacyPolicyContent" ref={containerPrivacyRef}>
                            <div className='font-bold font-libre-franklin text-xl'>Valoramos tu privacidad</div>
                            <div>{parse(privacyPolicyContent)}</div>
                        </div>
                        <div id='button_understood' onClick={() => setShowCookiesAdvice(true)} className='bg-[#100E9D] hover:bg-[#110f58] active:bg-[#8b8ab3] text-white cursor-pointer h-10 font-semibold text-base rounded-lg flex justify-center items-center p-4'>
                            {copys.understood}
                        </div>
                    </>
                }
            </div>
        </div>
    )
}

export default ModalCookies
